import { render, staticRenderFns } from "./personnelAuthorityManagement.vue?vue&type=template&id=1c136bc9&scoped=true"
import script from "./personnelAuthorityManagement.vue?vue&type=script&lang=js"
export * from "./personnelAuthorityManagement.vue?vue&type=script&lang=js"
import style0 from "./personnelAuthorityManagement.vue?vue&type=style&index=0&id=1c136bc9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c136bc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c136bc9')) {
      api.createRecord('1c136bc9', component.options)
    } else {
      api.reload('1c136bc9', component.options)
    }
    module.hot.accept("./personnelAuthorityManagement.vue?vue&type=template&id=1c136bc9&scoped=true", function () {
      api.rerender('1c136bc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authorityManagement/personnelAuthorityManagement.vue"
export default component.exports